import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import RetirementCalculatorService from "../../api/retirementCalculatorService";

export const getRetirementCal = createAsyncThunk(
  "projected-balance/filter",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await RetirementCalculatorService.getRetireCalData(
        payload,
      );
      //
      return response.data;
    } catch (error) {
      console.log("Retirement data catch === ", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  RetirementData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
};

const RetirementCalSlice = createSlice({
  name: "retirementData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRetirementCal.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getRetirementCal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.RetirementData = action.payload.RetirementData || {};
        state.successMessage =
          action.payload.message || "Successfully fetched Retirement Data Data";
        state.errorMessage = "";
      })
      .addCase(getRetirementCal.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      });
  },
});

export default RetirementCalSlice.reducer;
